// extracted by mini-css-extract-plugin
var _1 = "styles_header__XWsyq";
export { _1 as "header" }
